import React from 'react'

const OverviewCard = ({ title, data, style, values, type, onClick, showPercentage, totalCount = 0 }) => {

    const setPercentage = (value) => {
        const percent = totalCount > 0 ? (value * 100) / totalCount : 0;
        return `(${percent?.toFixed(2)}%)`
    };

    return (
        <div onClick={onClick} style={style} className="card">
            <div className="card-title">{title}</div>
            <div style={{ padding: '10px' }}>
                {data?.map((item, idx) => {
                    const renderValue = type == 'age' ? item?.age_count : values?.[item?.key] ? values?.[item?.key] : item?.default_value
                    return (
                        <div className='content-wrap' key={idx} >
                            <div className="card-content">{type == 'age' ? `${item?.age}:` : item?.label ? item?.label : ''}</div>
                            <div style={{ textAlign: 'center' }} className="card-value">{renderValue} {`${showPercentage ? setPercentage(renderValue) : ''}`}</div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default OverviewCard